module.exports = __webpack_public_path__ + "img/teeth-37.ae1167fa.png";